define('views/content/reseller_personals',['require','views/base/list_page_view','views/components/reseller_personal/reseller_personals','collections/reseller_personals','text!templates/content/reseller_personals.html'],function(require){

    var BaseListPageView = require('views/base/list_page_view');

    var ResellerPersonalsView = require('views/components/reseller_personal/reseller_personals');
    var ResellerPersonalsCollection = require('collections/reseller_personals');

    var temp = require("text!templates/content/reseller_personals.html");

    return BaseListPageView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'reseller-personal-page',
        titleKey: 'personals',

        setCollection: function () {
            this.collection = new ResellerPersonalsCollection();
        },

        onRender: function() {
            this.ListContainer.show(new ResellerPersonalsView({
                collection: this.collection
            }));
        }

    });
});
